import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import {documentTypes} from '../../config';

const FormMyAccount = ({ accountData }) => {

    return (
        <form>
            <div className="row">
                <div className="col-12 col-lg-6">
                    <div className="form-group">
                        <label>Nombres</label>
                        <input value={accountData.firstname || ''} readOnly={true} required maxLength="50" type="text" className="form-control" name="textBoxNombres" id="textBoxNombres" placeholder="Nombres" />
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="form-group">
                        <label>Apellidos</label>
                        <input value={accountData.lastname || ''} readOnly={true} required maxLength="50" type="text" className="form-control" name="textBoxApellidos" id="textBoxApellidos" placeholder="Apellidos" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-lg-4">
                    <div className="form-group">
                        <label>Tipo de documento</label>
                        <input value={(documentTypes.find(doc => doc.cod==accountData.docType)).title+' '+ (accountData.docNumber || '')} readOnly={true} required maxLength="30" type="text" className="form-control" name="textBoxDocumento" id="textBoxDocumento" disabled="disabled" />
                    </div>
                </div>
                <div className="col-12 col-lg-4">
                    <div className="form-group">
                        <label>Celular</label>
                        <span>+51</span> <input value={accountData.phone || ''} readOnly={true} required maxLength="30" type="tel" className="form-control" name="textBoxCelular" id="textBoxCelular" placeholder="Celular" />
                    </div>
                </div>
                <div className="col-12 col-lg-4">
                    <div className="form-group">
                        <label>Correo electrónico</label>
                        <input value={accountData.email || ''} readOnly={true} required maxLength="50" type="email" className="form-control" name="textBoxEmail" id="textBoxEmail" placeholder="Correo electrónico" />
                    </div>
                </div>
            </div>
        </form>
    );
}

FormMyAccount.propTypes = {
    accountData: PropTypes.object
};
export default FormMyAccount;